const config = {
    clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
    issuer: process.env.REACT_APP_OKTA_ISSUER,
    redirectUri: `${window.location.origin}/login/callback`,
    scopes: ['openid', 'profile', 'email'],
    pkce: true,
    tokenManager: {
        storage: "localStorage",
        autoRenew: false,
        autoRemove: true,
        expireEarlySeconds: 30,
    },
    storageManager: {
        token: {
            storageTypes: ["localStorage"],
        },
        cache: {
            storageTypes: ["sessionStorage"],
        },
    },
}
var OktaAuth = require('@okta/okta-auth-js').OktaAuth;
export const authClient = new OktaAuth(config)




// const config = {
//     clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
//     issuer: process.env.REACT_APP_OKTA_ISSUER,
//     redirectUri: `${window.location.origin}/login/callback`,
//     scopes: ['openid', 'profile', 'email', 'offline_access'],
//     pkce: true,
// }
// var OktaAuth = require('@okta/okta-auth-js').OktaAuth;
// export const authClient = new OktaAuth(config)
// Okta Bypass
export const isOktaDisabled = process.env.REACT_APP_DISABLE_OKTA === 'true' || process.env.VITE_DISABLE_OKTA === 'true';
export const devEmail = process.env.REACT_APP_DEV_EMAIL || process.env.VITE_DEV_EMAIL;
